
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 490.2 490.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#c60","d":"M266.2 88.6V9.9a9.86 9.86 0 10-19.8 0v78.8a9.86 9.86 0 009.9 9.9c5.5-.1 9.9-4.5 9.9-10zm-84.4 32.1c2.5 0 5.1-1 7-2.9 3.9-3.9 3.9-10.1 0-14l-55.7-55.7c-3.9-3.9-10.1-3.9-14 0s-3.9 10.1 0 14l55.7 55.7c1.9 1.9 4.5 2.9 7 2.9zM420 177h-78.8a9.86 9.86 0 100 19.8H420a9.86 9.86 0 100-19.8zm-337.4 9.9a9.86 9.86 0 009.9 9.9h78.8a9.86 9.86 0 100-19.8H92.5c-5.4 0-9.9 4.5-9.9 9.9zm246.8-63.4l55.7-55.7c3.9-3.9 3.9-10.1 0-14s-10.1-3.9-14 0l-55.7 55.7c-3.9 3.9-3.9 10.1 0 14 1.9 1.9 4.5 2.9 7 2.9s5.1-1 7-2.9z"}}),_c('path',{attrs:{"fill":"#777","d":"M60.3 293.5V465c0 10.8 8.8 19.5 19.5 19.5h58.3c6.7 0 12.5-3.3 16.1-8.4 9.3 8.7 21.7 14.1 35.4 14.1h156.2c35 0 57.3-18.4 61.3-50.4l21-133.6c.1-.5.1-1 .1-1.5 0-28.5-23.2-51.7-51.7-51.7h-78.1v-56.1c0-24.3-7.1-41.8-21.2-52.2-22.3-16.3-52.8-7-54.1-6.6-4.1 1.3-6.9 5.1-6.9 9.4v63.8c0 49.7-57.8 66.7-60.2 67.4-1.2.3-2.4.9-3.3 1.7-3.6-4-8.8-6.5-14.5-6.5H79.8c-10.8 0-19.5 8.8-19.5 19.6zm97.4 4.6c1.2.1 2.4 0 3.6-.3 3.1-.9 74.7-21.6 74.7-86.4v-55.9c7.7-1.2 20.4-1.6 29.5 5.2 8.7 6.4 13.1 18.6 13.1 36.1v66a9.86 9.86 0 009.9 9.9h88c17.4 0 31.5 13.9 31.9 31.2l-20.9 132.9v.3c-2.7 22-16.7 33.1-41.7 33.1H189.6c-17.6 0-31.9-14.3-31.9-31.9V298.1zm-77.6-4.4h57.8v171H80.1v-171z"}})])
          )
        }
      }
    